import React, { useState } from "react";
import Style from "./SearchFactur.module.css";
import { errorToast } from "../../../../Toast/Toast";
import { Button } from "antd";
const SearchFactur = ({ onSearchFacture,loadingState }) => {
  const [factureIdState, setFactureIdState] = useState("");
  const onSearchHandler = () => {
    if (!factureIdState) {
      errorToast("مقدار آیدی را وارد کنید");
      return;
    }
    onSearchFacture(factureIdState);
  };
  return (
    <div className={Style.SearchComponentHolder}>
      <input
        name="factureId"
        type="search"
        placeholder="لطفا شناسه فاکتور را وارد کنید"
        className={Style.SearchInput}
        value={factureIdState}
        onChange={(e) => setFactureIdState(e.target.value)}
      />
      <Button onClick={onSearchHandler} disabled={loadingState} loading={loadingState}>جست و جو</Button>
    </div>
  );
};

export default SearchFactur;
